// extracted by mini-css-extract-plugin
module.exports = {"lia-widget-btn":"PageEditorWidgetListItem_lia-widget-btn__zklut","lia-widget-btn-icon":"PageEditorWidgetListItem_lia-widget-btn-icon__WMVrB"};